import React from 'react';
import {connect} from 'react-redux';

import {getHeaders} from '../../../../selectors';

import Head from '../../Head';

const Headers = ({style, ...props}) => (
    <table className="fixed-headers" style={style}>
        <Head {...props} />
    </table>
);

const mapStateToProps = state => {
    const headers = getHeaders(state);
    const {timezone} = state;

    return {
        headers,
        timezone,
    };
};

export default connect(mapStateToProps)(Headers);
